
import { MousePointerIcon } from "lucide-react";
import React from "react";
import Threetry from './Styles/Threetry.svg'

export default function Hero({img}) {
  return (
    <main className="flex justify-center items-center">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16">
          <img className="h-[222px] w-auto" alt="Logo" src={img} />
        </div>
      </div>
    </main>
  );
}
